export const handleImg = (html) => {
  let result = html;
  if (!html) return '';
  const imageList = html.match(/<ac:image.*?ac:image>/gms) || [];

  imageList.forEach((imageItem) => {
    let codeTemp = imageItem;
    let imageWidthStyle = '';
    let imageHeightStyle = '';

    /*
      标签
      <ac:image ac:thumbnail="true" ac:height="250"></ac:image>
    */
    codeTemp = codeTemp.replace(/<ac:image/gms, '<div class="image"');
    codeTemp = codeTemp.replace(/\/ac:image>/gms, '/div>');
    codeTemp = codeTemp.replace(/ac:alt/gms, 'alt');
    codeTemp = codeTemp.replace(/ac:title/gms, 'title');
    codeTemp = codeTemp.replace(/ac:thumbnail="(.*?)"/gms, '');

    // 取出图片宽高
    const widthAttr = codeTemp.match(/ac:width=\"(.*?)\"/gms);
    const heightAttr = codeTemp.match(/ac:height=\"(.*?)\"/gms);

    if (widthAttr && widthAttr.length > 0) {
      const widthFromTag = widthAttr[0].replace(/ac:width=\"(.*?)\"/gms, '$1');
      if (widthFromTag) imageWidthStyle = `width:${widthFromTag}px;`;
    }
    if (heightAttr && heightAttr.length > 0) {
      const heightFromTag = heightAttr[0].replace(/ac:height=\"(.*?)\"/gms, '$1');
      if (heightFromTag) imageHeightStyle = `height:${heightFromTag}px;`;
    }

    /*
      图片使用iwiki附件
        <ri:attachment ri:filename="1477308454_21_w2448_h3264.JPG" />
      图片使用外网链接
        <ri:url ri:value="https://inews.gtimg.com/news_ls/O2e3XtB7ipOapSl-XKDMNAp9QxuJZp8mdxFCKdZRJxiaUAA_870492/0"></ri:url>
    */
    codeTemp = codeTemp.replace(
      /<ri:attachment ri:filename="(.*?)" \/>/gim,
      `<img style="${imageWidthStyle}${imageHeightStyle}" src="$1" />`,
    );
    codeTemp = codeTemp.replace(
      /<ri:url ri:value="(.*?)" \/>/gim,
      `<img style="${imageWidthStyle}${imageHeightStyle}" src="$1" />`,
    );

    result = result.replace(imageItem, codeTemp);
  });
  return result;
};
